var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-12 overflow-y-auto body-wrapper" },
    [
      _c(
        "div",
        {
          staticClass:
            "px-4 lg:px-64 pb-16 pt-20 text-center lg:pt-32 bg-center bg-[#fafafa]",
        },
        [
          _c(
            "h1",
            {
              staticClass:
                "font-display text-3xl xl:text-4xl 2xl:text-5xl font-bold tracking-tight text-slate-900 sm:text-5xl",
            },
            [
              _vm._v(" 中小非标机械厂 "),
              _c(
                "span",
                { staticClass: "relative whitespace-nowrap text-blue-600" },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "absolute left-0 top-2/3 h-[0.58em] w-full fill-blue-300/70",
                      attrs: {
                        "aria-hidden": "true",
                        viewBox: "0 0 418 42",
                        preserveAspectRatio: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z",
                        },
                      }),
                    ]
                  ),
                  _c("span", { staticClass: "relative" }, [_vm._v("ERP&MES")]),
                ]
              ),
              _vm._v(" 一体化管理系统 "),
            ]
          ),
          _c(
            "h3",
            {
              staticClass:
                "mt-12 text-sm lg:text-2xl tracking-wide text-slate-700",
            },
            [_vm._v(" 管好交期与库存，效益增长快人一步 ")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex items-center justify-center mt-6 text-sm lg:text-base tracking-wide text-[#666]",
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c("a-icon", {
                    staticClass: "mr-1",
                    attrs: { type: "check-circle" },
                  }),
                  _vm._v("即买即用 "),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex items-center ml-2" },
                [
                  _c("a-icon", {
                    staticClass: "mr-1",
                    attrs: { type: "check-circle" },
                  }),
                  _vm._v("无需实施 "),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex items-center ml-2" },
                [
                  _c("a-icon", {
                    staticClass: "mr-1",
                    attrs: { type: "check-circle" },
                  }),
                  _vm._v("操作简单 "),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex items-center ml-2" },
                [
                  _c("a-icon", {
                    staticClass: "mr-1",
                    attrs: { type: "check-circle" },
                  }),
                  _vm._v("3小时跑通 "),
                ],
                1
              ),
            ]
          ),
          _vm._m(0),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "px-4 lg:px-24 xl:px-64 py-8 text-center lg:py-16 border-y bg-[linear-gradient(180deg,#d1f2fd,rgba(209,242,253,0))]",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "font-display tracking-tight text-base lg:text-2xl mx-4 font-semibold",
            },
            [_vm._v(" " + _vm._s(_vm.steps.title) + " ")]
          ),
          _c(
            "div",
            { staticClass: "hidden lg:flex justify-center mt-6" },
            [
              _c(
                "a-row",
                { staticClass: "mt-6", attrs: { gutter: 16 } },
                _vm._l(_vm.steps.descs, function (item) {
                  return _c(
                    "a-col",
                    { key: item.title, attrs: { span: 8 } },
                    [
                      _c(
                        "a-card",
                        {
                          staticStyle: { height: "160px" },
                          attrs: { title: item.title },
                        },
                        [
                          _c("p", { staticClass: "font-[600]" }, [
                            _vm._v(_vm._s(item.desc)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex flex-col lg:hidden justify-center mt-6" },
            _vm._l(_vm.steps.descs, function (item) {
              return _c(
                "a-row",
                { key: item.title, staticClass: "mt-6" },
                [
                  _c(
                    "a-card",
                    {
                      staticStyle: { height: "160px" },
                      attrs: { title: item.title },
                    },
                    [_c("p", {}, [_vm._v(_vm._s(item.desc))])]
                  ),
                ],
                1
              )
            }),
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "px-4 lg:px-0 pt-8 text-center lg:pt-12 border-b" },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "font-display tracking-tight text-base lg:text-2xl mx-4 font-semibold",
                },
                [
                  _vm._v(
                    " 聚焦 4 大核心功能模块，打造中小型非标机械厂数智化转型第一步 "
                  ),
                ]
              ),
              _c(
                "a-tabs",
                {
                  staticClass: "pt-2 lg:pt-4 text-lg",
                  attrs: {
                    "default-active-key": "0",
                    size: "large",
                    animated: false,
                  },
                },
                _vm._l(_vm.modules, function (item, index) {
                  return _c(
                    "a-tab-pane",
                    {
                      key: String(index),
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "tab",
                            fn: function () {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "flex items-center text-sm lg:text-lg",
                                  },
                                  [_vm._v(" " + _vm._s(item.tabTitle) + " ")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c(
                        "a-row",
                        {
                          staticClass:
                            "hidden lg:flex flex-col lg:flex-row justify-center items-center px-4 lg:px-24 xl:px-64 py-4 lg:py-16",
                        },
                        [
                          _c(
                            "a-col",
                            {
                              staticStyle: { height: "100%" },
                              attrs: { span: 6 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex flex-col justify-start" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-lg text-left tracking-wide sm:text-xl md:text-xl font-semibold",
                                    },
                                    [_vm._v(" " + _vm._s(item.title) + " ")]
                                  ),
                                  _vm._l(item.descs, function (itemDesc) {
                                    return _c(
                                      "p",
                                      {
                                        key: itemDesc,
                                        staticClass:
                                          "max-w-lg flex items-center text-sm tracking-wide text-left lg:text-base mt-3 lg:mt-6",
                                      },
                                      [
                                        _c("a-icon", {
                                          staticClass:
                                            "mr-2 text-base text-green-500",
                                          attrs: { type: "check" },
                                        }),
                                        _vm._v(" " + _vm._s(itemDesc) + " "),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 18 } },
                            [
                              _c(
                                "a-carousel",
                                {
                                  staticClass:
                                    "ml-3 lg:ml-16 xl:ml-36 w-2/3 lg:w-[660px] rounded-xl mt-2 lg:mt-0",
                                  attrs: {
                                    dots: false,
                                    arrows: "",
                                    autoplay: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "custom-slick-arrow",
                                      staticStyle: {
                                        left: "10px",
                                        "z-index": "1",
                                      },
                                      attrs: { slot: "prevArrow" },
                                      slot: "prevArrow",
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "left-circle" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "custom-slick-arrow",
                                      staticStyle: { right: "10px" },
                                      attrs: { slot: "nextArrow" },
                                      slot: "nextArrow",
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "right-circle" },
                                      }),
                                    ],
                                    1
                                  ),
                                  index === 0
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/module1.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 0
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/module2.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 1
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/module3.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 1
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/module4.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 2
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/module5.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 2
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/module6.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 2
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/module7.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 3
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/module8.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 3
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/module9.png"),
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col justify-center items-center lg:hidden px-4 py-8",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col justify-start" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-base text-center tracking-wide sm:text-xl md:text-xl font-semibold",
                                },
                                [_vm._v(" " + _vm._s(item.title) + " ")]
                              ),
                              _vm._l(item.descs, function (itemDesc) {
                                return _c(
                                  "p",
                                  {
                                    key: itemDesc,
                                    staticClass:
                                      "max-w-lg flex items-center text-sm tracking-wide text-left lg:text-base mt-3 lg:mt-6",
                                  },
                                  [
                                    _c("a-icon", {
                                      staticClass:
                                        "mr-2 text-base text-green-500",
                                      attrs: { type: "check" },
                                    }),
                                    _vm._v(" " + _vm._s(itemDesc) + " "),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                          _c(
                            "a-carousel",
                            {
                              staticClass:
                                "w-5/6 lg:w-[660px] rounded-xl mt-2 lg:mt-0",
                              attrs: { dots: false, arrows: "", autoplay: "" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  staticStyle: { left: "10px", "z-index": "1" },
                                  attrs: { slot: "prevArrow" },
                                  slot: "prevArrow",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "left-circle" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  staticStyle: { right: "10px" },
                                  attrs: { slot: "nextArrow" },
                                  slot: "nextArrow",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "right-circle" },
                                  }),
                                ],
                                1
                              ),
                              index === 0
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/module1.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 0
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/module2.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 1
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/module3.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 1
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/module4.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 2
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/module5.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 2
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/module6.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 2
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/module7.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 3
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/module8.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 3
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/module9.png"),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "px-4 lg:px-0 pt-8 text-center lg:pt-12 border-b" },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "font-display tracking-tight text-base lg:text-2xl mx-4 font-semibold",
                },
                [_vm._v(" 生产大管家的能力，体现在每个细节 ")]
              ),
              _c(
                "a-tabs",
                {
                  staticClass: "pt-2 lg:pt-4 text-lg",
                  attrs: {
                    "default-active-key": "0",
                    size: "large",
                    animated: false,
                  },
                },
                _vm._l(_vm.features, function (item, index) {
                  return _c(
                    "a-tab-pane",
                    {
                      key: String(index),
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "tab",
                            fn: function () {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "flex items-center text-sm lg:text-lg",
                                  },
                                  [_vm._v(" " + _vm._s(item.title) + " ")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c(
                        "a-row",
                        {
                          staticClass:
                            "hidden lg:flex flex-col lg:flex-row justify-center items-center px-4 lg:px-24 xl:px-64 py-4 lg:py-16",
                        },
                        [
                          _c(
                            "a-col",
                            {
                              staticStyle: { height: "100%" },
                              attrs: { span: 6 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex flex-col justify-start" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-lg text-left tracking-wide sm:text-xl md:text-xl font-semibold",
                                    },
                                    [_vm._v(" " + _vm._s(item.title) + " ")]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "max-w-lg flex items-center text-sm tracking-wide text-left lg:text-base mt-3 lg:mt-6",
                                    },
                                    [_vm._v(" " + _vm._s(item.desc) + " ")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 18 } },
                            [
                              _c(
                                "a-carousel",
                                {
                                  staticClass:
                                    "ml-3 lg:ml-16 xl:ml-36 w-2/3 lg:w-[660px] rounded-xl mt-2 lg:mt-0",
                                  attrs: {
                                    dots: false,
                                    arrows: "",
                                    autoplay: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "custom-slick-arrow",
                                      staticStyle: {
                                        left: "10px",
                                        "z-index": "1",
                                      },
                                      attrs: { slot: "prevArrow" },
                                      slot: "prevArrow",
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "left-circle" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "custom-slick-arrow",
                                      staticStyle: { right: "10px" },
                                      attrs: { slot: "nextArrow" },
                                      slot: "nextArrow",
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "right-circle" },
                                      }),
                                    ],
                                    1
                                  ),
                                  index === 0
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/feature1.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 1
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/feature2.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 1
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/feature3.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 2
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/feature4.png"),
                                        },
                                      })
                                    : _vm._e(),
                                  index === 3
                                    ? _c("img", {
                                        staticClass:
                                          "lg:w-[660px] h-[380px] rounded-xl border border-solid border-[#9fc6ff]",
                                        attrs: {
                                          src: require("@/assets/imgs/home_products/feature5.png"),
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col justify-center items-center lg:hidden px-4 py-8",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col justify-start" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-base text-center tracking-wide sm:text-xl md:text-xl font-semibold",
                                },
                                [_vm._v(" " + _vm._s(item.title) + " ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "max-w-lg flex items-center text-sm tracking-wide text-left lg:text-base mt-3 lg:mt-6",
                                },
                                [_vm._v(" " + _vm._s(item.desc) + " ")]
                              ),
                            ]
                          ),
                          _c(
                            "a-carousel",
                            {
                              staticClass: "w-5/6 rounded-xl mt-2 lg:mt-0",
                              attrs: { dots: false, arrows: "", autoplay: "" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  staticStyle: { left: "10px", "z-index": "1" },
                                  attrs: { slot: "prevArrow" },
                                  slot: "prevArrow",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "left-circle" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  staticStyle: { right: "10px" },
                                  attrs: { slot: "nextArrow" },
                                  slot: "nextArrow",
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "right-circle" },
                                  }),
                                ],
                                1
                              ),
                              index === 0
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/feature1.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 1
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/feature2.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 1
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/feature3.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 2
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/feature4.png"),
                                    },
                                  })
                                : _vm._e(),
                              index === 3
                                ? _c("img", {
                                    staticClass:
                                      "lg:w-[660px] h-[200px] rounded-xl border border-solid border-[#9fc6ff]",
                                    attrs: {
                                      src: require("@/assets/imgs/home_products/feature5.png"),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "px-4 md:px-20 lg:px-24 xl:px-64 py-8 text-center lg:py-16 border-y",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "font-display tracking-tight text-lg lg:text-2xl mx-4 font-semibold",
            },
            [_vm._v(" " + _vm._s(_vm.envs.title) + " ")]
          ),
          _c(
            "div",
            { staticClass: "hidden lg:flex justify-center mt-6" },
            [
              _c(
                "a-row",
                {
                  staticClass: "mt-6",
                  staticStyle: { width: "100%" },
                  attrs: { gutter: 16 },
                },
                _vm._l(_vm.envs.descs, function (item) {
                  return _c(
                    "a-col",
                    { key: item.title, attrs: { span: 6 } },
                    [
                      _c("a-card", { attrs: { title: item.title } }, [
                        _c("p", [_vm._v(_vm._s(item.desc))]),
                      ]),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex flex-col lg:hidden justify-center mt-6" },
            _vm._l(_vm.envs.descs, function (item) {
              return _c(
                "a-row",
                {
                  key: item.title,
                  staticClass: "mt-6",
                  staticStyle: { width: "100%" },
                },
                [
                  _c("a-card", { attrs: { title: item.title } }, [
                    _c("p", [_vm._v(_vm._s(item.desc))]),
                  ]),
                ],
                1
              )
            }),
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "px-4 md:px-20 lg:px-24 xl:px-64 py-8 text-center lg:py-16 border-y bg-[linear-gradient(180deg,#c8f8e2,rgba(200,248,226,0))]",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "font-display tracking-tight text-lg lg:text-3xl mx-4 font-semibold",
            },
            [_vm._v(" " + _vm._s(_vm.customers.title) + " ")]
          ),
          _c(
            "div",
            { staticClass: "hidden lg:flex justify-center mt-6" },
            [
              _c(
                "a-row",
                { staticClass: "mt-6", attrs: { gutter: 16 } },
                _vm._l(_vm.customers.descs, function (item) {
                  return _c(
                    "a-col",
                    { key: item.title, attrs: { span: 8 } },
                    [
                      _c(
                        "a-card",
                        {
                          staticClass: "mb-4",
                          staticStyle: { height: "max-content" },
                          attrs: { title: item.title },
                        },
                        [
                          _c("p", { staticClass: "font-[600]" }, [
                            _vm._v(_vm._s(item.desc)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex flex-col lg:hidden justify-center mt-6" },
            _vm._l(_vm.customers.descs, function (item) {
              return _c(
                "a-row",
                { key: item.title, staticClass: "mt-6" },
                [
                  _c(
                    "a-card",
                    {
                      staticStyle: { height: "max-content" },
                      attrs: { title: item.title },
                    },
                    [
                      _c("p", { staticClass: "font-[600]" }, [
                        _vm._v(_vm._s(item.desc)),
                      ]),
                    ]
                  ),
                ],
                1
              )
            }),
            1
          ),
        ]
      ),
      _c("home-page-to-contact"),
      _c("home-page-contact"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-10 flex justify-center gap-x-6" }, [
      _c("div", { staticClass: "text-white" }, [
        _c(
          "a",
          {
            staticClass:
              "inline-flex items-center justify-center rounded-full py-2 lg:py-3 px-4 lg:px-8 text-base lg:text-lg font-semibold tracking-wide focus:outline-none bg-blue-600 hover:bg-blue-500",
            attrs: {
              variant: "solid",
              color: "slate",
              href: "/apply",
              target: "_blank",
            },
          },
          [_vm._v(" 体验Demo ")]
        ),
      ]),
      _c("div", { staticClass: "text-blue-600 hover:text-blue-500" }, [
        _c(
          "a",
          {
            staticClass:
              "inline-flex items-center justify-center rounded-full py-2 lg:py-3 px-4 lg:px-8 text-base lg:text-lg font-semibold tracking-wide focus:outline-none border border-blue-600",
            attrs: {
              variant: "solid",
              color: "slate",
              href: "/apply",
              target: "_blank",
            },
          },
          [_vm._v(" 预约演示 ")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }